import { useEffect } from 'react';

import {
	DISABLED_ATTACHMENT_ACTION_LOAD_STATE,
	useAttachmentActionLoadState,
	type AttachmentActionLoadState,
} from '@confluence/forge-ui/entry-points/useAttachmentActionLoadState.ts';

import type { AttachmentMacroExtensionState } from '../hooks/useAttachmentsMacroPerformance.ts';

export const AttachmentMacroExtensionPerformance = ({
	legacyActions = DISABLED_ATTACHMENT_ACTION_LOAD_STATE,
	onState,
}: {
	legacyActions?: AttachmentActionLoadState;
	onState: (state: AttachmentMacroExtensionState) => void;
}): null => {
	const { metadata, eligibility } = useAttachmentActionLoadState();
	const actions = eligibility.status === 'disabled' ? legacyActions : eligibility;
	useEffect(() => {
		onState({ metadata, actions });
	}, [actions, metadata, onState]);
	return null;
};
